export const filterRulesCopy = {
  title: '',
  action: '',
  details: '',
  createNewRule: '',
  filterIf: '',
  filterRuleContains: '',
  filterRuleDoesNotContain: '',
  filterRuleHasSuffix: '',
  filterAnd: '',
  filterThen: '',
  filterOr: '',
  filterHigh: '',
  filterNotHigh: '',
  filterMove: '',
  filterDelete: '',
  filterForward: '',
};
